import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { HttpHeadersService } from '../http-headers/http-headers.service';
import {
  PostResponseDocumentSubtypesRequestBody,
  ResponseDocumentSubtypesApiResponse,
  ResponseDocumentSubtype,
} from '../../../models/response-document-subtype';

export interface ResponseDocumentSubtypesResult {
  data: ResponseDocumentSubtype[];
}

@Injectable({
  providedIn: 'root',
})
export class ApiResponseDocumentSubtypesService {
  private url = `${environment.explainApiUrl}response_document_subtypes`;

  constructor(
    private http: HttpClient,
    private httpHeadersService: HttpHeadersService
  ) {}

  search(body: PostResponseDocumentSubtypesRequestBody): Observable<ResponseDocumentSubtypesResult> {
    return this.http.post<ResponseDocumentSubtypesApiResponse>(this.url, body, this.httpHeadersService.httpHeaders).pipe(
      map(res => ({
        data: res.data.map(item => ({
          id: item.id,
          name: item.name,
          displayedName: item.displayed_name,
          scope: item.scope,
        })),
      }))
    );
  }
}
